import { styled } from '@mui/system';

export const LastWhimContainer = styled('div')(({ theme }) => ({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  borderRadius: '10px',
  backgroundColor: 'white',
  border: '1px solid #EAEAEA',
  overflow: 'hidden',
  marginBottom: '160px',
  [theme.breakpoints.up('md')]: {
    marginBottom: 0,
  },
}));
